import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

import Navbar from "@/components/site/Navbar";
import Footer from "@/components/site/Footer";
import ScrollToTop from "@/components/site/ScrollToTop";
import TitleManager from "@/components/site/TitleManager";

import HomePage from "@/pages/HomePage";
import ForRepsPage from "@/pages/ForRepsPage";
import ForSurgeonsPage from "@/pages/ForSurgeonsPage";
import InduceXTPage from "@/pages/InduceXTPage";
import ProductsPage from "@/pages/ProductsPage";
import ContactPage from "@/pages/ContactPage";
import AdminPage from "@/pages/AdminPage";
import FaqPage from "@/pages/FaqPage";
import AboutPage from "@/pages/AboutPage";
import NotFoundPage from "@/pages/NotFoundPage";

function App() {
    return (
        <div className="App font-body">
            <BrowserRouter>
                <ScrollToTop />
                <TitleManager />
                <Navbar />
                <main>
                    <Routes>
                        <Route path="/" element={<HomePage />} />
                        <Route path="/for-reps" element={<ForRepsPage />} />
                        <Route path="/for-surgeons" element={<ForSurgeonsPage />} />
                        <Route path="/inducext" element={<InduceXTPage />} />
                        <Route path="/products" element={<ProductsPage />} />
                        <Route path="/contact" element={<ContactPage />} />
                        <Route path="/about" element={<AboutPage />} />
                        <Route path="/faq" element={<FaqPage />} />
                        <Route path="/admin" element={<AdminPage />} />
                        <Route path="*" element={<NotFoundPage />} />
                    </Routes>
                </main>
                <Footer />
            </BrowserRouter>
            <Toaster position="top-center" />
        </div>
    );
}

export default App;
